<template>
  <div>
    <LayoutOne v-if="layoutType === 'layout_one'" :binding-type="bindingType" />
    <LayoutTwo v-if="layoutType === 'layout_two'" :binding-type="bindingType" />
  </div>
</template>

<script>
  import LayoutOne from "./LayoutOne/LayoutOne.vue"
  import LayoutTwo from "./LayoutTwo/LayoutTwo.vue"

  export default {
    name: "LayoutSelector",
    components: {
      LayoutOne,
      LayoutTwo,
    },
    props: {
      layoutType: {
        type: String,
        default: "",
        required: true,
      },
      bindingType: {
        type: String,
        default: "",
      },
    },
  }
</script>
